import axios from "axios";
import VARS from "@/services/vars";

const api = axios.create({
  baseURL: VARS.API_URL,
  timeout: 30000,
});

/*
|--------------------------------------------------------------------------
| Request Interceptor
|--------------------------------------------------------------------------
*/
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

/*
|--------------------------------------------------------------------------
| Response Interceptor
|--------------------------------------------------------------------------
*/
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;

      // Unauthorized
      if (status === 401) {
        localStorage.removeItem("token");

        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
      }

      // Forbidden
      if (status === 403) {
        console.error("Access denied");
      }

      // Server Error
      if (status >= 500) {
        console.error("Server error");
      }
    } else if (error.request) {
      console.error("Network error");
    } else {
      console.error(error.message);
    }

    return Promise.reject(error);
  }
);

/*
|--------------------------------------------------------------------------
| Admin Profile
|--------------------------------------------------------------------------
*/
export function getAdminProfile() {
  return api.get("/api/admin/profile");
}

/*
|--------------------------------------------------------------------------
| Tenants
|--------------------------------------------------------------------------
*/
export function getTenants() {
  return api.get("/api/admin/tenants");
}

export function getTenant(id) {
  return api.get(`/api/admin/tenants/${id}`);
}

export function createTenant(payload) {
  return api.post("/api/admin/tenants", payload);
}

export function updateTenant(id, payload) {
  return api.put(`/api/admin/tenants/${id}`, payload);
}

export function deleteTenant(id) {
  return api.delete(`/api/admin/tenants/${id}`);
}

/*
|--------------------------------------------------------------------------
| Users
|--------------------------------------------------------------------------
*/
export function getUsers(params = {}) {
  return api.get("/api/admin/users", { params });
}

export function getUser(id) {
  return api.get(`/api/admin/users/${id}`);
}

export function createUser(payload) {
  return api.post("/api/admin/users", payload);
}

export function updateUser(id, payload) {
  return api.put(`/api/admin/users/${id}`, payload);
}

export function deleteUser(id) {
  return api.delete(`/api/admin/users/${id}`);
}

export function resetUserPassword(id, payload) {
  return api.post(`/api/admin/users/${id}/reset-password`, payload);
}

/*
|--------------------------------------------------------------------------
| Flows
|--------------------------------------------------------------------------
*/
export function getFlows(params = {}) {
  return api.get("/api/manager/flows", { params });
}

export function getFlow(id) {
  return api.get(`/api/manager/flows/${id}`);
}

export function createFlow(payload) {
  return api.post("/api/manager/flows", payload);
}

export function updateFlow(id, payload) {
  return api.put(`/api/manager/flows/${id}`, payload);
}

export function deleteFlow(id) {
  return api.delete(`/api/manager/flows/${id}`);
}

/*
|--------------------------------------------------------------------------
| Export API
|--------------------------------------------------------------------------
*/
export default api;